<template>
  <div class="lots-list tab-table p-2">
    <LotsTable :hide-actions="hideActions" :exclude-columns="['date', 'status', 'customer_uuid', 'winning_bidder', 'proposal_suggestion', 'proposal_status', 'new_low', 'new_high', 'new_reserve', 'new_start_price', 'proposal_sent_at', 'proposal_sent_by', 'proposal_confirmed_at', 'proposal_confirmed_by']"
               :exclude-search-fields="['start_date', 'end_date', 'status', 'customer_uuid', 'bidder_uuid', 'proposal_suggestion', 'proposal_status']" enable-frontend-export/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import LotsTable from "../../../lots/LotsTable";
  import _ from 'lodash';
  import {
    ACTION_ARCHIVE_LOT,
    ACTION_BATCH_LOT_UP, ACTION_BATCH_MARK_UNSOLD, ACTION_BATCH_UPDATE_HIDE_LOT, ACTION_BATCH_UPDATE_SESSION,
    ACTION_BULK_ADJUST_PRICE,
    ACTION_DELETE_LOT,
    ACTION_GENERATE_LOT_PRINTOUTS,
    ACTION_LOT_EXPORT_ALL_IMAGES,
    ACTION_LOT_UP, ACTION_LOT_UP_USING_EXCEL,
    ACTION_LOT_UP_USING_QR,
    ACTION_LOT_UPLOAD_IMAGES,
    ACTION_LOT_UPLOAD_ZIP,
    ACTION_MARK_UNSOLD,
    ACTION_PUBLISH_LOT,
    ACTION_REASSIGN_SALE,
    ACTION_RESERVE_ITEMS,
    ACTION_REVERT_TO_COMPLETED_LOT,
    ACTION_SYNC_LOTS
  } from "../../../constants";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: lotsMapActions} = createNamespacedHelpers('lots');

  export default {
    name: "LotsList",
    components: {LotsTable},
    data() {
      return {
        hideActions: [
          ACTION_LOT_UP,
          ACTION_LOT_UP_USING_QR,
          ACTION_BATCH_LOT_UP,
          ACTION_LOT_UPLOAD_IMAGES,
          ACTION_LOT_UPLOAD_ZIP,
          ACTION_MARK_UNSOLD,
          ACTION_GENERATE_LOT_PRINTOUTS,
          ACTION_DELETE_LOT,
          ACTION_LOT_EXPORT_ALL_IMAGES,
          ACTION_PUBLISH_LOT,
          ACTION_SYNC_LOTS,
          ACTION_ARCHIVE_LOT,
          ACTION_REVERT_TO_COMPLETED_LOT,
          ACTION_REASSIGN_SALE,
          ACTION_RESERVE_ITEMS,
          ACTION_BULK_ADJUST_PRICE,
          ACTION_LOT_UP_USING_EXCEL,
          ACTION_BATCH_UPDATE_SESSION,
          ACTION_BATCH_UPDATE_HIDE_LOT,
          ACTION_BATCH_MARK_UNSOLD
        ],
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    },
    methods: {
      ...lotsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'purchasedItems',
        extraFilters: {buyer_customer_uuid: this.customer.uuid},
        sale: _.cloneDeep(this.sale)
      })
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .btn-table-actions {
    display: none;
  }
</style>
